import { ASSET_DRAG_MIME } from "@/components/AssetsEditor/constants";
import AssetsListRow from "./AssetsListRow";
import AssetsListToolbar from "./AssetsListToolbar";
import { ASSETS_LIST_PANEL_HEIGHT } from "./constants";

export default function AssetsListLayout({
  listName,
  hasLoadedList,
  boxes,
  isDirty,
  isExpanded,
  isBusy,
  isDownloadingList,
  resolveAssetById,
  onToggleExpanded,
  onExpandForDrag,
  onNewList,
  onSaveList,
  onSaveListAs,
  onRenameList,
  onLoadList,
  onDeleteList,
  onDownloadList,
  onInsertAssetsAt,
  onMoveEntry,
  onRemoveEntry,
  onOpenEntryPreview,
}) {
  const panelStyle = isExpanded
    ? { height: `${ASSETS_LIST_PANEL_HEIGHT}px` }
    : undefined;

  // A collapsed strip has no drop gaps to land on, so a drag hovering over it
  // expands it — the same drag then keeps moving and lands on the row that
  // just appeared underneath it.
  const handleDragOver = (event) => {
    if (isExpanded) return;

    const draggedTypes = [...event.dataTransfer.types];
    if (!draggedTypes.includes(ASSET_DRAG_MIME)) return;

    event.preventDefault();
    event.stopPropagation();
    onExpandForDrag();
  };

  return (
    <div
      id="AssetsList"
      style={panelStyle}
      onDragOver={handleDragOver}
      onDragEnter={handleDragOver}
      className="AssetsList shrink-0 border-t flex flex-col min-h-0 overflow-hidden">
      <AssetsListToolbar
        listName={listName}
        hasLoadedList={hasLoadedList}
        entryCount={boxes.length}
        isDirty={isDirty}
        isExpanded={isExpanded}
        isBusy={isBusy}
        isDownloadingList={isDownloadingList}
        onToggleExpanded={onToggleExpanded}
        onNewList={onNewList}
        onSaveList={onSaveList}
        onSaveListAs={onSaveListAs}
        onRenameList={onRenameList}
        onLoadList={onLoadList}
        onDeleteList={onDeleteList}
        onDownloadList={onDownloadList}
      />

      {isExpanded && (
        <div className="AssetsList__body flex items-stretch flex-1 min-h-0 px-2 pb-2">
          <AssetsListRow
            boxes={boxes}
            resolveAssetById={resolveAssetById}
            onInsertAssetsAt={onInsertAssetsAt}
            onMoveEntry={onMoveEntry}
            onRemoveEntry={onRemoveEntry}
            onOpenEntryPreview={onOpenEntryPreview}
          />
        </div>
      )}
    </div>
  );
}
